// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"03ae10b9","232":"63a83b58","237":"1167812b","357":"0fa697e3","526":"d70f51ef","787":"c4e7f8f9","872":"6133aba9"}[chunkId] + ".chunk.js";
};